import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=3f0b485c"
import script from "./Snackbar.vue?vue&type=script&lang=js"
export * from "./Snackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f0b485c')) {
      api.createRecord('3f0b485c', component.options)
    } else {
      api.reload('3f0b485c', component.options)
    }
    module.hot.accept("./Snackbar.vue?vue&type=template&id=3f0b485c", function () {
      api.rerender('3f0b485c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/alert/Snackbar.vue"
export default component.exports